module.exports = __webpack_public_path__ + "static/media/mini-arrow.66a7c1c5.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/mini-arrow.svg
// module id = 124
// module chunks = 0